// extracted by css-extract-rspack-plugin
export default {"important":"important-vl_lka"};